import { Component, output } from '@angular/core';

@Component({
  selector: 'app-team-setup-cta',
  imports: [],
  templateUrl: './team-setup-cta.component.html',
  styleUrls: ['./team-setup-cta.component.css'],
})
export class TeamSetupCtaComponent {
  readonly openOnboarding = output<void>();

  onSetupTeam() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.openOnboarding.emit();
  }
}
